module.exports = __webpack_public_path__ + "img/40.e3db673f.jpg";